import { Grid, GridItem } from '@chakra-ui/react';
import { CustomFieldEntityEnum, IProductResSchema } from '@monetize/types/app';
import { MFormField, MText } from '..';
import { ROUTES } from '../../../constants';
import {
  PRODUCT_STATUS_ENUM_DISPLAY,
  PRODUCT_TYPE_DISPLAY,
} from '../../../constants/products';
import { PRODUCT_EDIT_ROLES } from '../../../constants/roles';
import { CustomFieldDataForm } from '../../CustomFields/CustomFieldDataForm';
import { RecordLookupPopover } from './RecordLookupPopover';
import { RecordLookupPopoverHeader } from './RecordLookupPopoverHeader';

export interface ProductLookupPopoverProps {
  productId: string;
  label: string;
  hideEditLink?: boolean;
}

export function ProductLookupPopover({
  productId,
  label,
  hideEditLink,
}: ProductLookupPopoverProps) {
  return (
    <RecordLookupPopover
      recordId={productId}
      endpoint={`/api/products/${productId}`}
      buttonProps={{ lineClamp: 4 }}
      renderRecord={(record) => {
        const product = record as IProductResSchema;
        return (
          <>
            <RecordLookupPopoverHeader
              recordId={product.id}
              href={ROUTES.getProductEditRoute(product.id)}
              recordName={product.name}
              displayStatus={PRODUCT_STATUS_ENUM_DISPLAY[product.status]}
              roles={PRODUCT_EDIT_ROLES}
              hideEditLink={hideEditLink}
            />

            <Grid gridTemplateColumns="1fr 1fr" rowGap={4} mt={4}>
              <GridItem>
                <MFormField label="Status">
                  <MText>{PRODUCT_STATUS_ENUM_DISPLAY[product.status]}</MText>
                </MFormField>
              </GridItem>
              <GridItem>
                <MFormField label="Type">
                  <MText>{PRODUCT_TYPE_DISPLAY[product.productType]}</MText>
                </MFormField>
              </GridItem>
              {product.description && (
                <GridItem colSpan={2}>
                  <MFormField label="Description">
                    <MText lineClamp={3}>{product.description}</MText>
                  </MFormField>
                </GridItem>
              )}
              {product.customId && (
                <MFormField label="Custom ID">
                  <MText>{product.customId}</MText>
                </MFormField>
              )}
              {product.sku && (
                <MFormField label="SKU">
                  <MText>{product.sku}</MText>
                </MFormField>
              )}
              {product.financeId && (
                <MFormField label="Finance ID">
                  <MText>{product.financeId}</MText>
                </MFormField>
              )}
            </Grid>
            <CustomFieldDataForm
              entity={CustomFieldEntityEnum.PRODUCT}
              value={product.customFields || {}}
              isReadOnly
              setValue={() => {}}
              fieldColSpan={6}
              mode="modal"
            />
          </>
        );
      }}
    >
      {label}
    </RecordLookupPopover>
  );
}
